import { render, staticRenderFns } from "./DialogRemoveArticleProject.vue?vue&type=template&id=17e4c267&scoped=true"
import script from "./DialogRemoveArticleProject.vue?vue&type=script&lang=js"
export * from "./DialogRemoveArticleProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e4c267",
  null
  
)

export default component.exports